import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import Services from './services';
import SwichButton from '../../../commons/SwitchButton';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import { Button, Label } from 'reactstrap';
import SelectField from '../../../components/Form/SelectField';

const COL_STYLE = {marginBottom: '15px'};
const ROW_STYLE = {marginLeft: '15px', marginRight: '15px'};

const EloadasFilter = props => {
  const {
    setFilter
  } = props;
  const initialStatus = 'AKTIV';
  const initialTitle = '';
  const initialGenre = null;
  const [status, toggleStatus] = useState(initialStatus);
  const [title, setTitle] = useState(initialTitle);
  const [genre, setGenre] = useState(initialGenre);
  const [firstLoad, setFirstLoad] = useState(true);
  const active = status === 'AKTIV';
  
  const loadMufajOptions = (input, callback) => {
    Services.listMufajok(input, (err, res) => {
      if (!err) {
        let options = [];
        res[0].filter( k => !k.angol && k.nev.toLowerCase().includes(input.toLowerCase())).forEach((item) => {
          options.push(item);
        });
        callback(options);
      }
    });
  }

  const startKereses = () => {
    setFilter(
      {
        allapot: status,
        cim: title,
        mufajId: genre && genre.id,
      }
    );
  }

  useEffect(() => {
    if (!firstLoad && (!title || title.length > 2)) {
      startKereses();
    }
    setFirstLoad(false);
  }, [genre, status, title]);

  return(
    <React.Fragment>
      <div className="row" >
        <div className="col-md-2">
          <h5>Szűrési feltételek: </h5>
        </div>
      </div>
      <RFForm onSubmit={e => e.preventDefault()} >
        <div className="row" style={ROW_STYLE}>
          <div className="col-md-3" style={COL_STYLE}>
            <RFField
              label="Cím: "
              name={"title"}
              value={title}
              onChange={_.debounce((e, v) => {
                const val = e.target.value;
                if(!val || (val.length >= 3)){
                  setTitle(e.target.value);
                }
              }, 1000)}
            />
          </div>
          <div className="col-md-3" style={COL_STYLE}>
            <SelectField
              variant='async'
              label='Műfaj:'
              name="genre"
              id="genre"
              placeholder="Kezdj el gépelni..."
              noOptionsMessage={() => 'Nincs keresési eredmény'}
              onChange={v => setGenre(v)}
              loadOptions={_.debounce(loadMufajOptions, 1000)}
              getOptionLabel={option => option.nev}
              getOptionValue={option => option.id}
              value={genre}
              defaultOptions
              isClearable
            />
          </div>
          <div className="col-md-auto" style={COL_STYLE}>
            <Label for={"status"}>Státusz: </Label>
            <SwichButton
              name="status"
              id="status"
              active={active}
              trueLabel="Aktív"
              trueToggle={() => toggleStatus('AKTIV')}
              trueWidth={80}
              falseToggle={() => toggleStatus('INAKTIV')}
              falseLabel="Inaktív"
              falseWidth={80}
            />
          </div>
        </div>
      </RFForm>
    </React.Fragment>
  );
}

export default EloadasFilter;